import { Grid } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../Styles/claimManagement";

const CarryForwardAssignationProcessTable = ({
    clickSubmitHandler,
    salesTeamDataList,
    onChangeTextField,
    formErrorForDetails,

}) => {
    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {
            let isValid = false;
            let name =
                currentRow.name != null ? currentRow.name : "";
            let carryForwardDays =
                currentRow.carryForwardDays != null ? currentRow.carryForwardDays : "";
            let balance =
                currentRow.balance != null ? currentRow.balance : "";
            let carryForwardLeave =
                currentRow.carryForwardLeave != null ? currentRow.carryForwardLeave : "";

            if (
                name &&
                name.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                carryForwardDays &&
                carryForwardDays.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            else if (
                balance &&
                balance.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            else if (
                carryForwardLeave &&
                carryForwardLeave.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    return (
        <>
            {salesTeamDataList.length !== 0 && (
                <>
                    <LandingScreenHeader
                        screenTitle={""}
                        showSearchBox={true}
                        showTable={true}
                        showFilter={false}
                        showPdfDownload={false}
                        showExcelDownload={false}
                        onSearch={onSearchValue}
                    />

                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "500px",
                            position: "relative",
                        }}
                    >
                        <table
                            style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#03a9f4",
                                    zIndex: 3,
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            ...claimManagementStyles.tableHeadStyle,
                                            minWidth: "100px",
                                        }}
                                    >
                                        Sr. No
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "200px", }}>
                                        Leave Type
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "190px", }}>
                                        Carry Forward Leave
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {getFilteredTableData(salesTeamDataList).map((dataObj, index) => (
                                    <tr key={dataObj.id}>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            {dataObj.index !== null ? dataObj.index : ""}
                                        </td>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "left",
                                            }}
                                        >
                                            {dataObj.name !== null ? dataObj.name : ""}
                                        </td>

                                        <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                <input
                                                    type="number"
                                                    name={"carryForwardDays"}
                                                    value={dataObj.carryForwardDays}
                                                    onChange={(e) => onChangeTextField(e, dataObj.id)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "-" || e.key === "+") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    style={{
                                                        width: "150px",
                                                        padding: "4px 6px",
                                                        fontSize: "14px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        textAlign: "center",
                                                    }}
                                                />
                                            </div>
                                            {formErrorForDetails?.[`carryForwardDaysError${dataObj.id}`] && (
                                                <div style={{ color: "red", fontSize: 12, textAlign: "center", marginTop: 4 }}>
                                                    {formErrorForDetails[`carryForwardDaysError${dataObj.id}`]}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <br />
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="flex-end"
                        gap={2}
                    >
                        <ButtonCompo
                            sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                            }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Submit"}
                            onClick={clickSubmitHandler}
                            fullWidth={false}
                        />
                    </Grid>
                </>
            )}
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CarryForwardAssignationProcessTable);
